import {Component} from '@angular/core';
import {BaseModalComponent} from "../../../views/modal/base_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormControl} from "@angular/forms";
import {BaseFormGroup} from "../../../models/form";
import {SupportService} from "../support.service";

@Component({
	template: `
		<base-modal
			[title]="title"
			[btnOkClass]="'btn-warning'"
			[btnOkLabel]="'Запустить'"
			[isLoading]="isLoading"
			(onOk)="ok()"
		>
			<div class="alert alert-info" role="alert">
				Выберите действие для восстановления виджетов
			</div>

			<form [formGroup]="form">
				<div class="form-group">
					<div class="form-check">
						<label class="form-check-label">
							<input class="form-check-input" type="radio"
								   formControlName="action"
								   value="check">
							Проверить
						</label>
					</div>

					<div class="form-check">
						<label class="form-check-label">
							<input class="form-check-input" type="radio"
								   formControlName="action"
								   value="fix">
							Исправить
						</label>
					</div>
				</div>
			</form>

			<div class="alert" [ngClass]="resultClass" role="alert" *ngIf="resultMessage" style="margin-top: 15px;">
				<pre style="white-space: pre-wrap; margin-bottom: 0;">{{ resultMessage }}</pre>
			</div>
		</base-modal>
	`
})
export class FixWidgetsModalComponent extends BaseModalComponent {
	title: string;
	siteId: string;
	action: string = 'check';
	resultMessage: string = '';
	resultClass: string = '';

	constructor(
		public activeModal: NgbActiveModal,
		private supportService: SupportService
	) {
		super(activeModal);

		this.form = new BaseFormGroup({
			action: new FormControl(this.action)
		});
	}

	ngOnInit() {
		this.form.valueChanges.subscribe(({ action }) => {
			this.action = action;
		});
	}

	async ok() {
		const me = this;

		me.isLoading = true;

		try {
			const response = await me.supportService.fixWidgets(me.siteId, me.action, 'Fix widgets').toPromise();
			me.isLoading = false;

			// Проверяем наличие report в ответе
			let hasProblems = false;

			if (response.report) {
				if (Array.isArray(response.report)) {
					hasProblems = response.report.length > 0;
				} else if (typeof response.report === 'object') {
					// Проверяем, есть ли ключи в объекте (не пустой ли {})
					hasProblems = Object.keys(response.report).length > 0;
				} else {
					hasProblems = !!response.report;
				}
			}

			if (hasProblems) {
				// Если report содержит данные, выводим его
				if (Array.isArray(response.report)) {
					me.resultMessage = JSON.stringify(response.report, null, 2);
				} else if (typeof response.report === 'object') {
					me.resultMessage = JSON.stringify(response.report, null, 2);
				} else {
					me.resultMessage = response.report.toString();
				}
				me.resultClass = 'alert-warning';
			} else {
				// Если report пустой или отсутствует (включая {})
				me.resultMessage = 'Проблем не обнаружено';
				me.resultClass = 'alert-success';
			}
		} catch (error) {
			me.isLoading = false;
			me.resultMessage = 'Ошибка: ' + (error.message || 'Неизвестная ошибка');
			me.resultClass = 'alert-danger';
		}
	}
}
